
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['error'],
};
